<div *ngIf="type === 'user'">
    <div *ngFor="let item of userStatusBlocks()" class="status-div">
        <div class="circle-left circle-green" *ngIf="item.status === userStatusEnum.active"></div>
        <div
            class="circle-left circle-red"
            *ngIf="item.status === userStatusEnum.disabled || item.status === 'deactivated'"></div>
        <div
            class="circle-left circle-yellow"
            *ngIf="item.status === userStatusEnum.pending_review"></div>
        <div
            class="circle-left circle-orange"
            *ngIf="item.status === userStatusEnum.pending_kyc"></div>
        {{ item.label | humanize }}
    </div>
</div>

<div *ngIf="type === 'file'">
    <div *ngFor="let item of fileBlocks()" class="status-div">
        <div class="circle-left circle-green" *ngIf="item.status === fileStatusEnum.verified"></div>
        <div
            class="circle-left circle-red"
            *ngIf="item.status === fileStatusEnum.verification_failed"></div>
        <div
            class="circle-left circle-yellow"
            *ngIf="item.status === fileStatusEnum.pending_verification"></div>
        {{ item.label | humanize }}
    </div>
</div>

<div *ngIf="type === 'transaction'">
    <div *ngIf="transactionStatus" class="status-div">
        <div
            class="circle-left circle-green"
            *ngIf="transactionStatus === transactionStatusEnum.success"></div>
        <div
            class="circle-left circle-blue"
            *ngIf="transactionStatus === transactionStatusEnum.onhold"></div>
        <div
            class="circle-left circle-red"
            *ngIf="transactionStatus === transactionStatusEnum.failed"></div>
        <div
            class="circle-left circle-red"
            *ngIf="transactionStatus === transactionStatusEnum.cancelled"></div>
        <div
            class="circle-left circle-yellow"
            *ngIf="transactionStatus === transactionStatusEnum.pending"></div>
        <div
            class="circle-left circle-orange"
            *ngIf="transactionStatus === transactionStatusEnum.processing"></div>
        {{ transactionStatus === 'onhold' ? 'On Hold' : (transactionStatus | humanize) }}
    </div>
</div>
<div *ngIf="type === 'bank_transfer'">
    <div *ngIf="transactionStatus" class="status-div">
        <div
            class="circle-left circle-green"
            *ngIf="transactionStatus === transactionStatusEnum.success"></div>
        <div
            class="circle-left circle-green"
            *ngIf="transactionStatus === transactionStatusEnum.settled"></div>
        <div
            class="circle-left circle-red"
            *ngIf="transactionStatus === transactionStatusEnum.failed"></div>
        <div
            class="circle-left circle-red"
            *ngIf="transactionStatus === transactionStatusEnum.cancelled"></div>
        <div
            class="circle-left circle-yellow"
            *ngIf="transactionStatus === transactionStatusEnum.pending"></div>
        <div
            class="circle-left circle-yellow"
            *ngIf="transactionStatus === 'payment pending'"></div>
        <div
            class="circle-left circle-orange"
            *ngIf="transactionStatus === transactionStatusEnum.processing"></div>
        {{ transactionStatus === 'success' ? 'received' : (transactionStatus | humanize) }}
    </div>
</div>
<div *ngIf="type === 'sagePayExportLog'">
    <div *ngIf="status" class="status-div">
        <div
            class="circle-left circle-green"
            *ngIf="status === sagepayExportLogStatus.successful"></div>
        <div
            class="circle-left circle-red"
            *ngIf="status === sagepayExportLogStatus.successfulWithErrors"></div>
        <div
            class="circle-left circle-red"
            *ngIf="status === sagepayExportLogStatus.unsuccessful"></div>
        {{ status | humanize }}
    </div>
</div>

<div *ngIf="type === 'banner'" class="status-div">
    <div class="circle-left circle-green" *ngIf="status === 'true'"></div>
    <div class="circle-left circle-red" *ngIf="status !== 'true'"></div>
    {{ status | humanize }}
</div>

<!-- <div *ngIf="type === 'banner'" class="status-div">
    <div class="circle-left circle-green" *ngIf="status === 'true'"></div>
    <div class="circle-left circle-red" *ngIf="status !== 'true'"></div>
    {{status | humanize}}
</div>
 -->
